
export class IncomeProofDTO {
    constructor(
        public uid?: string,
        public proofType?: string,
        public fileFolderUid?: string,
        public linkToType?: string,
        public linkToId?: string,
        public linkToUid?: string,
        public contextType?: string,
        public contextId?: string,
        public contextUid?: string,
        public version?: number,
        public deleteBtnDisabled?: boolean,//added for client side use this paramenter will not come from server
        ) { }
}